import * as React from "react";
import Input from "../Input-new/Input";
import Dropdown from "../Dropdown/Dropdown";
import Textarea from "../Textarea-new/Textarea";

const TenantInfo = ({ isExists,typeDuplicate,data, handleChangeInput, viewMode, deleted,handleChangeDropdown,handleParentDropdownChange,theme = 'white' }) => {
  function getCompanyZIP()
    {
        if(viewMode == true && typeof data.zip !== 'undefined' && data.zip != null && data.zip.length < 5)
        {
            data.zip = '0'.repeat(5 - data.zip.length) + data.zip
        }
        if(data.zip == null || data.zip == '00000' || data.zip == '')
        {
            data.zip = ''
        }
        return data.zip;
    }
  return (
    <div className="Tenant-info">
      <div className="Tenant-info_column">
      {(isExists) && <p className="errorText">{typeDuplicate ? typeDuplicate : " Given Tenant Details Already Exists"}</p>}
        {/* <Input
          className="Tenant-info_column_item"
          required
          valueType="text"
          name="name"
          label="NAME"
          value={data.name}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        /> */}
         <Input
          className="Tenant-info_column_item"
          required
          valueType="text"
          name="first_name"
          label="First Name"
          value={data.first_name}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Tenant-info_column_item"
          required
          valueType="text"
          name="last_name"
          label="Last Name"
          value={data.last_name}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Tenant-info_column_item"
          //name="COMPANY_ADDRESS"
          name="address"
          label="Company Address"
          //value={data.COMPANY_ADDRESS}
          value={data.address}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Tenant-info_column_item"
          valueType="text"
          //name="CITY"
          name="city"
          label="CITY"
          //value={data.CITY}
          value={data.city}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />

        <Dropdown
          className="Tenant-info_column_item"
          data={data}
          optionsType="states"
          optionKey="abbr"
          optionLabelKey="name"
          // value={data.STATE}
          // valueKey="STATE"
          value={data.state}
          valueKey="state"
          label="STATE"
          handleParentChange={handleChangeDropdown}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Tenant-info_column_item"
          //name="COMPANY_ZIP"
          name="zip"
          label="Zip"
          value={getCompanyZIP()}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Dropdown
          className="Tenant-info_column_item"
          dropdownType='multiple'
          optionsType='contactType'
          value={Array.isArray(data.contact_type) ? data.contact_type.join(",") : data.contact_type || ""}
          valueKey='contact_type'
          label='Contact Type'
          data={data}
          handleParentChange={handleParentDropdownChange}
          viewMode={viewMode}
        />
      </div>

          <div className="Tenant-info_column"> 
        <div> 
        {data.contact_type && (Array.isArray(data.contact_type) ? data.contact_type.some((type) => type.split(",").includes("Team")  )  : data.contact_type.split(",").includes("Team")) ?
        // data.contact_type && (data.contact_type.includes("Team")) ?
        <Input
          className="Tenant-info_column_item"
          required
          valueType="phone"
          name="cell_phone"
          label="Cell Phone"
          value={data.cell_phone}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        : ""
        }
        
        {data.contact_type && (Array.isArray(data.contact_type) ? data.contact_type.some((type) => type.split(",").includes("Team")  )  : data.contact_type.split(",").includes("Team")) ?
        //data.contact_type && (data.contact_type.includes("Team")) ?
        <Input
          className="Tenant-info_column_item"
          required
          valueType="email"
          name="email"
          label="Email"
          value={data.email}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        : ""
      }
      {/* {data.contact_type && (data.contact_type.includes("Lender")) ? */}
         {data.contact_type && (Array.isArray(data.contact_type) ? data.contact_type.some((type) => type.split(",").includes("Lender")  )  : data.contact_type.split(",").includes("Lender")) ?

          <Input
            className="Tenant-info_column_item"
            name="name"
            required
            label="Company"
            value={data.name}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
          />
          : ""
        }
        {/* {data.contact_type && (data.contact_type.includes("Lender")) ? */}
        {/* {data.contact_type && (Array.isArray(data.contact_type) ? data.contact_type.some((type) => type.split(",").includes("Lender")  )  : data.contact_type.split(",").includes("Lender")) ?

          <Textarea
            className="Tenant-info_column_item"
            required
            valueType="text"
            inputType="textarea"
            //name="notes"
            name="notes"
            label="Notes"
            //value={data.NOTES}
            value={data.notes}
            viewMode={viewMode}
            handleParentChange={handleChangeInput}
            deleted={deleted}
            maxWidth="100%"
          /> : ""
        } */}
      </div>
      </div>
    </div>
  );
};

export default TenantInfo;
